import { createApp } from "vue"

import HelloVue from "../components/HelloVue.vue"
import AllVmListFilter from "../components/AllVmListFilter.vue"
import HyperVisorListResults from "../components/HyperVisorListResults.vue"
import IsoImageFilter from "../components/IsoImageFilter.vue"
import IsoImageResults from "../components/IsoImageResults.vue"
import NetworkTabs from "../components/NetworkTabs.vue"
import UserListResults from "../components/UserListResults.vue"
import VmDetailPanel from "../components/VmDetailPanel.vue"
import VmImageDetailPanel from "../components/VmImageDetailPanel.vue"
import VmImageFilter from "../components/VmImageFilter.vue"
import VmImageTabs from "../components/VmImageTabs.vue"
import VmListFilter from "../components/VmListFilter.vue"
import VmListResults from "../components/VmListResults.vue"
import VmTemplateResults from "../components/VmTemplateResults.vue"
import VmTemplateFilter from "../components/VmTemplateFilter.vue"

const registry = {
  "hello-vue": HelloVue,
  "all-vm-list-filter": AllVmListFilter,
  "hyper-visor-list-results": HyperVisorListResults,
  "iso-image-filter": IsoImageFilter,
  "iso-image-results": IsoImageResults,
  "network-tabs": NetworkTabs,
  "user-list-results": UserListResults,
  "vm-detail-panel": VmDetailPanel,
  "vm-image-detail-panel": VmImageDetailPanel,
  "vm-image-filter": VmImageFilter,
  "vm-image-tabs": VmImageTabs,
  "vm-list-filter": VmListFilter,
  "vm-list-results": VmListResults,
  "vm-template-results": VmTemplateResults,
  "vm-template-filter": VmTemplateFilter
}

function collectProps(element) {
  const raw = element.dataset.vueProps

  if (!raw) {
    return {}
  }

  try {
    return JSON.parse(raw)
  } catch (error) {
    console.warn("Failed to parse data-vue-props", error)
    return {}
  }
}

function mountVueComponents() {
  document.querySelectorAll("[data-vue-component]").forEach((element) => {
    const componentName = element.dataset.vueComponent
    const component = registry[componentName]

    if (!component || element.dataset.vueMounted === "true") {
      return
    }

    createApp(component, collectProps(element)).mount(element)
    element.dataset.vueMounted = "true"
  })
}

document.addEventListener("DOMContentLoaded", mountVueComponents)
window.sccMountVueComponents = mountVueComponents

export { mountVueComponents }
